import React from 'react';
import { Image, Book, GraduationCap, Map, Users } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <Image className="w-7 h-7 md:w-10 md:h-10 text-gold-600" data-id="element-110" />,
    title: 'Más de 280 Imágenes en Alta Resolución',
    desc: <span data-id="element-111">
          <span className="font-bold text-gray-900" data-id="element-112">Reconstrucciones 3D</span>,{' '}
          <span className="font-bold text-gray-900" data-id="element-113">mapas detallados</span> y{' '}
          <span className="font-bold text-gray-900" data-id="element-114">fotografías reales</span> de
          los sitios bíblicos. Es como tener un{' '}
          <span className="italic text-gold-700" data-id="element-115">
            guía arqueológico personal
          </span>{' '}
          a tu lado.
        </span>
  }, {
    icon: <Book className="w-7 h-7 md:w-10 md:h-10 text-gold-600" data-id="element-116" />,
    title: 'Cobertura Total: Los 66 Libros',
    desc: <span data-id="element-117">
          Contexto visual de{' '}
          <span className="font-bold text-burgundy-700 highlight-gold" data-id="element-118">
            CADA libro
          </span>{' '}
          de la Biblia. Todo en un{' '}
          <span className="underline-subtle font-medium" data-id="element-119">solo recurso</span>.
        </span>
  }, {
    icon: <GraduationCap className="w-7 h-7 md:w-10 md:h-10 text-gold-600" data-id="element-120" />,
    title: 'Profundidad Académica con Contexto Arqueológico',
    desc: <span data-id="element-121">
          Geografía física detallada, clima, vegetación y{' '}
          <span className="font-bold text-gray-900" data-id="element-122">
            datos arqueológicos verificados
          </span>
          .
        </span>
  }, {
    icon: <Map className="w-7 h-7 md:w-10 md:h-10 text-gold-600" data-id="element-123" />,
    title: 'Mapas Detallados por Período y Región',
    desc: <span data-id="element-124">
          Ver <span className="font-bold text-burgundy-700" data-id="element-125">EXACTAMENTE</span>{' '}
          cómo se veía el territorio{' '}
          <span className="italic" data-id="element-126">antes de leer cada pasaje</span>.
        </span>
  }, {
    icon: <Users className="w-7 h-7 md:w-10 md:h-10 text-gold-600" data-id="element-127" />,
    title: 'Perfecto Para Principiantes y Estudiosos Avanzados',
    desc: <span data-id="element-128">
          Contenido para{' '}
          <span className="font-bold text-navy-800 highlight-warm" data-id="element-129">
            TODOS los niveles
          </span>{' '}
          de conocimiento bíblico.
        </span>
  }];
  return <section className="py-8 md:py-16 bg-white content-section" data-id="element-130">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-131">
        <div className="text-center mb-6 md:mb-12" data-id="element-132">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-133">
            ¿Qué Hace de Esta una Guía Visual{' '}
            <span className="italic text-gold-600" data-id="element-134">"Perfecta"</span>?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-135">
            Debe ser lo suficientemente detallada para{' '}
            <span className="font-bold text-gray-800" data-id="element-136">
              no dejar NADA a la imaginación
            </span>
            , pero lo suficientemente clara para que{' '}
            <span className="underline-subtle" data-id="element-137">
              cualquier creyente la disfrute
            </span>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-138">
          {features.map((feature, index) => <div key={index} className="bg-parchment-50 p-4 md:p-6 rounded-xl border border-gold-100 hover:shadow-lg transition-shadow" data-id="element-139">
              <div className="mb-2 md:mb-4 bg-white w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center shadow-sm border border-gold-100" data-id="element-140">
                {feature.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-gray-900 mb-2 md:mb-3" data-id="element-141">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-142">{feature.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}